import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { FillScreen } from '@/components/Layout';
import { LIST_EMPTY_DATA } from '@/lib/listPage';

import DataTableCard from './-components/DataTableCard';
import FilterBarButtons from './-components/FilterBarButtons';
import FilterBarTabs from './-components/FilterBarTabs';
import useGetRoles from './-queries/useGetRoles';
import useGetRolesCount from './-queries/useGetRolesCount';
import { SearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/settings/permission-and-roles/_list/roles/',
)({
  validateSearch: zodValidator(SearchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const { data: rolesRes, isPending } = useGetRoles({ search });

  const { data: countRes } = useGetRolesCount({ search });

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <FilterBarTabs search={search} navigate={navigate} countRes={countRes} />

      <FilterBarButtons search={search} navigate={navigate} />

      <DataTableCard
        search={search}
        navigate={navigate}
        rolesRes={rolesRes ?? LIST_EMPTY_DATA}
        isPending={isPending}
      />
    </FillScreen>
  );
}
